import { ContractFeeChargeOne } from '@Common/types/bo/b2b/contract_fee_charges';

export const b2bContractFeeChargesTranslations = {
  sections: {
    details: 'Détails',
    paid_by: 'Qui paie les frais?',
    information: 'Informations',
    total_fee: 'Montant total des frais',
    confirmation: {
      summary: 'Résumé des frais et confirmation',
      paid_by: 'À la charge de',
      company_name: 'Nom de l’entreprise',
      contract_number: 'Numéro de contrat',
      fee_type: 'Type de frais',
      amount: 'Montant',
    },
  },
  actions: {
    create: {
      success: 'Frais créé',
      failure: 'Échec de la création des frais : %{error}',
      title: 'Créer un frais',
    },
  },
  steps: {
    general_details: 'Détails généraux',
    confirmation: 'Confirmation',
  },
  hints: {
    pereco_custody:
      'Saisir le montant calculé : %{rate} % de l’encours PERECO, plafonné à %{max} €. Le préremplissage depuis un salarié n’est pas encore disponible.',
  },
  paid_by_values: {
    company: 'Entreprise',
    user: 'Adhérent',
  } satisfies Record<ContractFeeChargeOne['paid_by'], string>,
  fee_label: {
    company_file_opening: 'Frais ouverture de dossier',
    affiliate_account_closure: "Forfait d'écrêtement de cloture de compte",
    affiliate_account_position_at_given_date: 'Edition de position (hors succession)',
    affiliate_collective_operation_by_cheque:
      "Règlement d'une Participation, Intéressement, Prime partage de valeur par chèque pour perception immédiate",
    affiliate_annual_custody_for_former_or_retired_employees: 'Frais de tenue de compte',
    affiliate_annual_custody_for_former_or_retired_employees_pereco:
      'Frais de tenue de compte PERECO',
    affiliate_undelivered_mail_handling: 'Frais de lettre A/R envoyée pour adresse invalide',
    affiliate_direct_debit_rejection: 'Frais chèque impayé ou rejet de prélèvement ',
    affiliate_estate_settlement_high_amount: 'Rachat anticipé pour succession >5000€',
    affiliate_estate_settlement_low_amount: 'Rachat anticipé pour succession 500-5000€',
    affiliate_pledging_or_release_of_assets: "Nantissement ou mainlevée de l'épargne",
    affiliate_reissue_bank_transfer: "Réémission d'un virement en France",
    affiliate_repayment_by_cheque: 'Rachat par chèque',
    affiliate_specific_mail_requests_processing: 'Traitement spécifiques',
    affiliate_reissue_cheque: "Réémission d'un chèque",
    affiliate_repayment_of_savings:
      'Opération de rachat (déblocage anticipé, disponible, retraite) demandée par courrier',
    affiliate_repayment_reimbursement_triggered:
      'Rachat avec condition de déclenchement, demandé par courrier',
    affiliate_retractation_following_pereco_payment: 'Retractation Versement PERECO',
    affiliate_search_for_documents_or_transactions_after_10_years:
      'Frais de recherche opération plus de 10 ans',
    affiliate_search_for_documents_or_transactions_before_10_years:
      'Frais de recherche opération moins de 10 ans',
    affiliate_statements_and_certificates: 'Editions releves, attestations',
    affiliate_transfer_from_pee_to_another_manager:
      'Facturation des transferts individuels perdants (forfait)',
    affiliate_transfer_from_pereco_to_another_manager_pct:
      'Facturation des transferts individuels perdants sur PERECO (1%)',
    affiliate_voluntary_payment_by_cheque: 'Tarification de versement volontaire par chèque',
    company_calculating_individual_allocations_particip: 'Calcul des quotes-parts Participation HT',
    company_calculating_individual_allocations_profit: 'Calcul des quotes-parts Intéressement HT',
    company_ccb_annual_fee: 'Forfait annuel CCB HT',
    company_ccb_fee_per_account: 'Tarif CCB par compte individuel HT',
    company_collective_transfer_to_another_manager:
      'Frais de transfert collectif HT (max 1 000 eur)',
    company_fee_per_account: 'Tarif PEE/PERCO (ou PERECO) par compte individuel HT',
    company_integration_of_affiliates_choices_via_mail_particip:
      'Retour par courrier avis d’option Participation HT',
    company_integration_of_affiliates_choices_via_mail_profit:
      'Retour par courrier avis d’option Intéressement HT',
    company_integration_of_affiliates_choices_via_mail_value:
      'Retour par courrier avis d’option Prime partage de valeur HT',
    company_integration_of_affiliates_consultation_data_particip:
      'Intégration des fichiers hors WEB Participation HT',
    company_integration_of_affiliates_consultation_data_profit:
      'Intégration des fichiers hors WEB Intéressement HT',
    company_integration_of_affiliates_consultation_data_value:
      'Intégration des fichiers hors WEB Prime partage de valeur HT',
    company_integration_of_affiliates_data: 'Intégration des fichiers hors WEB Affiliation HT',
    company_other: 'Prestations spécifiques diverses',
    company_pee_fee_per_account: 'Tarif PEE par compte individuel HT',
    company_pee_pereco_annual_fee: 'Forfait annuel PERCO/PERECO HT',
    company_pereco_fee_per_account: 'Tarif PERCO (ou PERECO) par compte individuel HT',
    company_publishing: "Prestations éditiques (relevés d'opérations salariés entre autres) HT",
    company_rejection_of_direct_debit_or_bank_transfer: 'Rejet prélèvement ou virement HT',
    company_soles_annual_fee_tc: 'Forfait annuel global HT',
    company_soles_annual_reduced_fee_tc: 'Forfait réduit annuel global HT',
    company_soles_fee_tc_per_affilliate: 'Tarif Soles par bénéficiaire HT',
    company_soles_reduced_fee_tc_per_affilliate: 'Tarif Soles réduit par bénéficiaire HT',
  } satisfies Record<ContractFeeChargeOne['fee_label'], string>,
  fields: {
    id: 'ID des frais',
    paid_by: 'Payé par',
    b2b_contract_id: 'ID du contrat',
    b2b_company_id: 'ID de l’entreprise',
    b2b_contract_version_num: 'Version du contrat',
    fee_label: 'Libellé',
    amount: 'Montant',
    updated_at: 'Mis à jour le',
    created_at: 'Créé le',
  } satisfies Record<keyof ContractFeeChargeOne, string>,
};
